import { produceWithPatches } from "immer";
import { FC } from "react";
//import { UseTranslationContext } from "../Context/TranslationContext";
import MUITooltipCustom from "./MUITooltipCustom";
import { FormattedValue } from "../hooks/dataFormatter";

export type ResultSectionComponentModel = 'SECTION_TITLE' | 'SECTION_TITLE_VALUE';

interface SalarySimResultProps {
    modelType: ResultSectionComponentModel;
    modelText: string;
    modelValue: number;
    modelTooltip?: string;
    modelTooltipAlt?: string;
    modelTooltipPlacement?: string;
}

const ResultSectionComponent: FC<SalarySimResultProps> = (props) => {
    //const{getKeyFromKeyId} = UseTranslationContext();


    const GenerateComponent = () => {
        switch (props.modelType) {
            case "SECTION_TITLE": 
                return(
                    <>
                        {/* <h4 className="sub-title-result">{getKeyFromKeyId(props.modelText)}</h4> */}
                        <h4 className="sub-title-result">
                            {props.modelText}
                            {props.modelTooltip && props.modelTooltipAlt &&
                                <MUITooltipCustom tooltipText={props.modelTooltip} buttonAltText={props.modelTooltipAlt} placement={props.modelTooltipPlacement||"left"}/>
                            }
                        </h4>
                    </>
                );
            break;
            case "SECTION_TITLE_VALUE": 
                return(
                    <>
                        {/* <h4 className="sub-title">{getKeyFromKeyId(props.modelText)}</h4> */}
                        <h4 className="sub-title">
                            {props.modelText}
                            {props.modelTooltip && props.modelTooltipAlt &&
                                <MUITooltipCustom tooltipText={props.modelTooltip} buttonAltText={props.modelTooltipAlt} placement={props.modelTooltipPlacement||"left"}/>
                            }
                        </h4>
                                               
                        <p id="total-imposable-data" className="sum total">
                            {(props.modelValue==null || props.modelValue==undefined) ? 0: FormattedValue(props.modelValue) }</p>
                    </>
                );
                break;
            default: 
                return (<></>);
            break;
        }
    }

    return (
        <>
            {GenerateComponent()}
        </>
    );
}

export default ResultSectionComponent;